import { gql } from "@apollo/client";

const ESCAPE_FIELDS = gql`
  fragment MyEscapeFields on EscapeType {
    id
    gameDate
    escapeTime
    isEscaped
    myReview {
      id
      components(extended: true) {
        id
        response {
          comment
          optionId
        }
      }
      images {
        id
        imageKey
      }
      isContainingSpoilers
      overallRating
      privacy
      privateNotes
      summary
    }
    pictures {
      id
      imageId
      imageKey
    }
    taggedUsers {
      id
      firstName
      imageId
      lastName
      username
    }
  }
`;

export const JOIN_ESCAPE_MUTATION = gql`
  ${ESCAPE_FIELDS}

  mutation JoinEscape($escapeId: ID!, $review: ReviewMutationInput, $taggedUsers: [ID]) {
    joinEscape(escapeId: $escapeId, review: $review, taggedUsers: $taggedUsers) {
      escape {
        ...MyEscapeFields
      }
    }
  }
`;

export const QUERY = gql`
  ${ESCAPE_FIELDS}

  query Game($id: ID!, $isUser: Boolean!) {
    game(id: $id) {
      id
      communityRatingCount
      communityScoreBucket
      communityScorePercentages {
        percentage
        rating
      }
      difficulty
      gameimageSet {
        id
        imageId
      }
      kind
      location {
        id
        company {
          id
          name
          slug
        }
        displayName
        slug
      }
      minutes
      myEscape @include(if: $isUser) {
        ...MyEscapeFields
      }
      name
      playersMax
      playersMin
      primaryCategory {
        id
        name
        slug
        parent {
          id
          name
          slug
        }
      }
      slug
    }
    reviewComponents(gameId: $id) @include(if: $isUser) {
      id
      description
      isCommentable
      isHighlighted
      options {
        id
        value
      }
      question
      type
    }
  }
`;

export const UPDATE_ESCAPE_MUTATION = gql`
  ${ESCAPE_FIELDS}

  mutation UpdateEscape(
    $escape: EscapeMutationInput!
    $experienceReview: ExperienceReviewMutationInput
    $review: ReviewMutationInput
  ) {
    updateEscape(escape: $escape, experienceReview: $experienceReview, review: $review) {
      escape {
        ...MyEscapeFields
      }
    }
  }
`;
